import createIcon from '../../createIcon';

/**
 * @component @name MoveUp
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMy41IDEzLjVDMy41IDExLjA1IDUuMjYgOS4wMyA3LjU4IDguNTlMNi4wOSAxMC4wOUw3LjUgMTEuNUwxMS41IDcuNDlMNy41IDMuNUw2LjA5IDQuOTFMNy42NyA2LjQ5VjYuNTVDNC4yIDYuOTYgMS41IDkuOTIgMS41IDEzLjVDMS41IDE3LjM3IDQuNjMgMjAuNSA4LjUgMjAuNUgxMS41VjE4LjVIOC41QzUuNzQgMTguNSAzLjUgMTYuMjYgMy41IDEzLjVaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTMuNSAxMy41VjIwLjVIMjIuNVYxMy41SDEzLjVaTTIwLjUgMTguNUgxNS41VjE1LjVIMjAuNVYxOC41WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTIyLjUgNC41SDEzLjVWMTEuNUgyMi41VjQuNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const MoveUp = createIcon('MoveUp', [
  [
    'path',
    {
      d: 'M3.5 13.5C3.5 11.05 5.26 9.03 7.58 8.59L6.09 10.09L7.5 11.5L11.5 7.49L7.5 3.5L6.09 4.91L7.67 6.49V6.55C4.2 6.96 1.5 9.92 1.5 13.5C1.5 17.37 4.63 20.5 8.5 20.5H11.5V18.5H8.5C5.74 18.5 3.5 16.26 3.5 13.5Z',
      key: '3nbdl9',
    },
  ],
  ['path', { d: 'M13.5 13.5V20.5H22.5V13.5H13.5ZM20.5 18.5H15.5V15.5H20.5V18.5Z', key: '17vmm9' }],
  ['path', { d: 'M22.5 4.5H13.5V11.5H22.5V4.5Z', key: '1dftxq' }],
]);

export default MoveUp;
